// @flow

import * as React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

import type { CommonActionProps } from './types.actions';
import ButtonAction from './ButtonAction';
import Base from "../../layout/Base.layout";
import isLoggedInQuery from "../../graphql/queries/isLoggedIn.query";

type Props = {
  refetch: () => mixed,
};

class RefreshAction extends React.Component<CommonActionProps & Props> {
  static defaultProps = {
    size: 'xsmall',
  };

  isUserLoggedIn = () => {
    Base.getClient().query({query: isLoggedInQuery, fetchPolicy: 'network-only'})
  }

  render() {
    return (
      <ButtonAction
        onClick={() => {
          this.isUserLoggedIn();
          this.props.refetch();
        }}
        bsSize={this.props.size}
        disabled={this.props.disabled}
      >
        <Glyphicon glyph="refresh" /> Refresh
      </ButtonAction>
    );
  }
}

export default RefreshAction;
